require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-were-like-wine-we-get-better-with-time.json") })
        }
      }, "path---blog-were-like-wine-we-get-better-with-time");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-were-like-wine-we-get-better-with-time!./.cache/json/blog-were-like-wine-we-get-better-with-time.json
// module id = 280
// module chunks = 231608221292675